module.exports = __webpack_public_path__ + "media/coffee-preferences/brew_method_coffee_maker-186a5fc2.png";